import { baseApi } from '@app/store/index.api';

import {
  ITraderWalletResponse,
  IChangeTraderWalletStatusQuery,
  IChangeTraderWalletStatusResponse,
  IApproveTraderWalletResponse,
  IRejectTraderWalletResponse,
} from '../model/types';

const traderWalletApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTraderWallets: builder.query<ITraderWalletResponse, string>({
      query: query => {
        return {
          url: `/pd/trader-wallets/deposit?${query}`,
        };
      },
    }),
    changeTraderWalletStatus: builder.mutation<
      IChangeTraderWalletStatusResponse,
      IChangeTraderWalletStatusQuery
    >({
      query: ({ id, status, reason }) => {
        return {
          url: `/trader-wallets/${id}/status`,
          method: 'PATCH',
          body: reason ? { status, reason } : { status },
        };
      },
    }),
    approveTraderWallet: builder.mutation<IApproveTraderWalletResponse, string>({
      query: id => {
        return {
          url: `/pd/trader-wallets/${id}/approve`,
          method: 'PATCH',
        };
      },
    }),
    rejectTraderWallet: builder.mutation<IRejectTraderWalletResponse, string>({
      query: id => {
        return {
          url: `/pd/trader-wallets/${id}/reject`,
          method: 'PATCH',
        };
      },
    }),
    getTraderWalletStatement: builder.query<Blob, string>({
      query: id => ({
        url: `/pd/trader-wallets/${id}/statement/download`,
        responseHandler: response => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetTraderWalletsQuery,
  useChangeTraderWalletStatusMutation,
  useApproveTraderWalletMutation,
  useRejectTraderWalletMutation,
  useLazyGetTraderWalletStatementQuery,
} = traderWalletApi;
